// extracted by mini-css-extract-plugin
export default {"settingsPage":"SettingsPage_settingsPage__mIzIX","mainArea":"SettingsPage_mainArea__71qt0"};